export type TenantRollupCronTriggerFilter =
  'all' | 'cron' | 'auto_retry_request' | 'manual_retry_bulk' | 'manual_missed_bulk' | 'manual_resend';

export const TENANT_ROLLUP_CRON_TRIGGER_FILTERS: {
  value: TenantRollupCronTriggerFilter;
  label: string;
}[] = [
  { value: 'all', label: 'All sources' },
  { value: 'cron', label: 'Scheduled cron' },
  { value: 'auto_retry_request', label: 'Auto retry' },
  { value: 'manual_retry_bulk', label: 'Bulk retry requests' },
  { value: 'manual_missed_bulk', label: 'Bulk missed' },
  { value: 'manual_resend', label: 'Manual resend' },
];

export function tenantRollupCronTriggerFilterParam(filter: TenantRollupCronTriggerFilter): string | null {
  return filter === 'all' ? null : filter;
}

export function formatTenantRollupCronTriggerSource(source: string | null | undefined): string {
  if (!source?.trim()) return '—';
  const match = TENANT_ROLLUP_CRON_TRIGGER_FILTERS.find((f) => f.value === source);
  if (match) return match.label;
  return source.replace(/_/g, ' ');
}

export function parseTenantRollupCronTriggerSourceFilter(
  source: string | null | undefined,
): TenantRollupCronTriggerFilter | null {
  if (!source?.trim()) return null;
  const value = source.trim();
  if (value === 'all') return null;
  const match = TENANT_ROLLUP_CRON_TRIGGER_FILTERS.find((f) => f.value === value);
  return match ? match.value : null;
}

export function formatTenantRollupCronTriggerFilterAppliedMessage(
  filter: TenantRollupCronTriggerFilter,
): string {
  return `Failure log filtered to ${formatTenantRollupCronTriggerSource(filter)}.`;
}
